module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "component-policy"
  }, [_c('div', {
    staticClass: "inner-content"
  }, [(_vm.$is('listing')) ? [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "column shrink"
  }, [_c('dropdown', {
    attrs: {
      "icon": 'fa fa-ellipsis-v fa-2x action',
      "position": 'top'
    }
  }, [(_vm.item.status === 'PROCESSING') ? [_c('div', {
    staticClass: "dropdown-buttons"
  }, [_c('ActionButton', {
    attrs: {
      "action": _vm.stopProcessing
    }
  }, [_vm._v("Stop")])], 1)] : _vm._e()], 2)], 1), _c('div', {
    staticClass: "column shrink"
  }, [_c('div', {
    staticClass: "field"
  }, [_vm._v("C" + _vm._s(_vm.item.id))])]), _c('div', {
    staticClass: "column shrink"
  }, [_c('div', {
    staticClass: "field"
  }, [_vm._v("Operation:")]), _c('div', {
    staticClass: "field"
  }, [_vm._v(_vm._s(_vm.item.operation))])]), _c('div', {
    staticClass: "column small-6"
  }, [_c('div', {
    staticClass: "field"
  }, [_vm._v("Payload:")]), _c('div', {
    staticClass: "field"
  }, [_vm._v(_vm._s(JSON.stringify(_vm.item.payload)))])]), _c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "field"
  }, [_vm._v("Status:")]), _c('div', {
    staticClass: "field"
  }, [_vm._v(_vm._s(_vm.item.status)), (_vm.item.info) ? [_c('div', {
    staticClass: "field"
  }, [_c('small', [_vm._v(_vm._s(_vm.item.info.processing) + "/" + _vm._s(_vm.item.info.total) + " (" + _vm._s(Math.round(_vm.item.info.processing / _vm.item.info.total * 100)) + "%)")])])] : _vm._e()], 2)]), _c('div', {
    staticClass: "column shrink"
  }, [_c('div', {
    staticClass: "field"
  }, [_vm._v("Output:")]), (_vm.item.output) ? _c('div', {
    staticClass: "field"
  }, [_c('a', {
    on: {
      "click": function($event) {
        return _vm.openUrl(_vm.item.output)
      }
    }
  }, [_vm._v("Download")])]) : _vm._e()]), _c('div', {
    staticClass: "column shrink"
  }, [_c('div', {
    staticClass: "field-url-detail"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'cargo-operation',
        params: {
          id: _vm.item.id
        }
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-right fa-3x action"
  })])], 1)])])] : _vm._e(), (_vm.$is('detail')) ? [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "card p-3"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "column shrink"
  }, [_c('div', {
    staticClass: "field"
  }, [_vm._v("Operation:")]), _c('div', {
    staticClass: "field"
  }, [_vm._v(_vm._s(_vm.item.operation))])]), _c('div', {
    staticClass: "column shrink"
  }, [_c('div', {
    staticClass: "field"
  }, [_vm._v("Status:")]), _c('div', {
    staticClass: "field"
  }, [_vm._v(_vm._s(_vm.item.status))]), (_vm.item.info && _vm.item.status === 'PROCESSING') ? [_c('div', {
    staticClass: "field"
  }, [_c('small', [_vm._v(_vm._s(_vm.item.info.processing) + "/" + _vm._s(_vm.item.info.total) + " (" + _vm._s(Math.round(_vm.item.info.processing / _vm.item.info.total * 100)) + "%)")])])] : _vm._e()], 2), _c('div', {
    staticClass: "column shrink"
  }, [_c('div', {
    staticClass: "field"
  }, [_vm._v("Info")]), _c('pre', {
    staticStyle: {
      "font-family": "monospace"
    }
  }, [_vm._v(_vm._s(_vm.item.info))])]), _c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "field"
  }, [_vm._v("Payload:")]), _c('pre', [_vm._v(_vm._s(_vm.item.payload))])]), _c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "field"
  }, [_vm._v("Result:")]), _c('div', {
    staticClass: "field"
  }, [_vm._v(_vm._s(JSON.stringify(_vm.item.result)))])]), _c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "field"
  }, [_vm._v("Output:")]), (_vm.item.output) ? _c('div', {
    staticClass: "field"
  }, [_c('a', {
    on: {
      "click": function($event) {
        return _vm.openUrl(_vm.item.output)
      }
    }
  }, [_vm._v("Download")])]) : _vm._e()])])])])])] : _vm._e()], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-40c47d55!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/backoffice/Cargo.vue
// module id = 2430
// module chunks = 1